<template>
  <div class="d-flex jc-center">
    <spinner v-if="isFetching" size="100px" class="m-t-6"/>
    <div v-else class="MESSAGES-CONTAINER">
      <div class="d-flex">

        <div class="HEADER">
          <div class="d-flex ai-center">
            <router-link :to="{name: 'dashboard::pro::messages'}">
              <vk-icon
                  v-if="$device.isMobile"
                  name="arrow-left"
                  size="30"
                  class=" m-t-1 c-depot" />
            </router-link>
            <avatar
                :name="fullName"
                :size="35"
                class="flex-0-0 as-center m-x-2"
                selenium="message-avatar"/>
            <div class="text-bold">
              {{ fullName }}
            </div>
          </div>
          <a @click.prevent="openHistoryJobModal" class="link">
            View Job Details
          </a>
        </div>
      </div>
      <transition-group
          name="FADE"
          tag="div"
          appear
          v-infinite-scroll.reverse="{
            offset: 666,
            promise: currentJobMessagesMeta.hasMore
              && (!isFetching || !isCreating)
              && loadMoreMessages
          }"
          class="MESSAGES-LIST-CONTAINER">
        <transition-group
            name="FADE"
            tag="div"
            v-for="(rawMessages, group) in
            getGroupedByDateCurrentRawMessagesByJobId(job.order_hash)"
            :key="group"
            class="GROUP">
          <transition-group
              name="FADE-AND-MOVE"
              tag="div"
              key="content"
              class="d-flex fd-column-reverse">
            <message-bubble
                v-for="message in rawMessages"
                :key="message.message_id"
                :message="message"
                class="LIST-ITEM"
            />
          </transition-group>
        </transition-group>
      </transition-group>
      <div
          v-if="hasFiles || isUploading"
          class="FILES-CONTAINER"
          selenium="uploaded-files"
          :class="{ 'x-pulse': isUploading, 'DISABLED': isUploading || isMessagingDisabled }">
        <gallery :files="newFiles" deletable class="FILES" @deleteImage="onFileDelete" />
      </div>
      <div
          v-if="hasCurrentJobMessagesError || hasCurrentJobFilesError || hasNewMessageError"
          class="ERROR"
          selenium="messages-error">
        <error-messages
            v-if="hasCurrentJobFilesError"
            :error="currentJobFilesMeta.error"
            default-message="Failed to upload your attachment. Please try again later..." />
        <error-messages
            v-if="hasCurrentJobMessagesError"
            :class="{ 'm-t-1': hasCurrentJobFilesError }"
            :error="currentJobMessagesMeta.error"
            default-message="Failed to send your message. Please try again later..." />
        <error-messages
            v-if="hasNewMessageError"
            :class="{ 'm-t-1': hasCurrentJobMessagesError }"
            :error="validation.firstError('newMessage')" />
      </div>
      <div class="TEXTAREA-CONTAINER">


        <!-- <label
            class="ATTACH"
            selenium="messages-attach"> -->

        <button
            class="ATTACH"
            type="button"
            :disabled="isMessagingDisabled"
            @click="openGallery"
            style="background: none; border: none; padding: 0; margin: 0;"
        >
          <vk-icon
              name="picture"
              class="LARGE-ICON"
          />
        </button>

        <!-- Hidden file input (triggered from popup) -->
        <input
            ref="galleryInput"
            :disabled="isMessagingDisabled"
            accept="image/*"
            multiple
            type="file"
            class="HIDDEN"
            @change="onNewFilesUpload"
            selenium="messages-attach-gallery"
        />
        <input
            ref="cameraInput"
            :disabled="isMessagingDisabled"
            accept="image/*"
            capture="environment"
            type="file"
            class="HIDDEN"
            @change="onNewFilesUpload"
            selenium="messages-attach-camera"
        />

        <!-- </label> -->
        <textarea-input
            :disabled="isMessagingDisabled"
            ref="textarea"
            v-model="newMessage"
            :placeholder="`Message ${job.location.first_name}...`"
            class="TEXTAREA"
            selenium="text-input"
            @keypress.native.enter="onNewMessageCreateWithShiftPlusEnter"
        />
        <a
            class="SEND"
            selenium="send-button"
            :class="{ 'DISABLED': isSendingDisabled }"
            @click.prevent="onNewMessageCreate">
          <vk-icon name="paperplane" />
        </a>
      </div>
    </div>
    <history-job-modal
        v-if="isHistoryJobModalOpen"
        @close="close"
        :job="selectedJob"/>
    <vk-modal class="gallery-popup-overlay" v-if="showGalleryPopup" @close="closeGalleryPopup">
      <div class="gallery-popup">
        <div class="popup-content">
          <h3>Select Images</h3>
          <button
              class="BUTTON"
              @click="() => { this.$refs.galleryInput.click(); closeGalleryPopup(); }"
          >
            Choose from Gallery
          </button>
          <button class="BUTTON" @click="openCamera">Capture from Camera</button>
          <button class="BUTTONCLOSE" @click="closeGalleryPopup">Close</button>
        </div>
      </div>
    </vk-modal>
    <div
        v-if="isUploading"
        class="UPLOAD-LOADER-OVERLAY"
        selenium="messages-upload-loader">
      <loading-indicator :size="64" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { shouldBeDisabled } from '@homeservices/tool-kit/proreferral/utils/messages';
import SimpleVueValidator, { Validator } from 'simple-vue-validator';
import { VALID_IMAGE_ACCEPT_TYPES, DEFAULT_MAX_IMAGE_SIZE } from '@/constants';
import jobParams from '@/mixins/job-params';
import job from '@/mixins/job';
import messages from '@/mixins/job/messages'; // TODO - messages, this should be removed as it is no longer correct
import files from '@/mixins/job/files';
import SlidingModal from '@/views/Dashboard/components/SlidingModal';
import ErrorMessages from '@/views/Dashboard/components/ErrorMessages';
import TextareaInput from '@/views/Dashboard/components/TextareaInput';
import passEducation from '@/views/Dashboard/mixins/pass-education';

import { SUB_STATUS_OPTIONS } from '@/constants/sub-status-options';
import HistoryJobModal from '@/views/Dashboard/views/Performance/components/History/components/HistoryJobModal';
import MessageBubble from './MessageBubble';

export default {
  VALID_IMAGE_ACCEPT_TYPES,
  DEFAULT_MAX_IMAGE_SIZE,
  SUB_STATUS_OPTIONS,
  shouldBeDisabled,
  name: 'pro-messages',
  components: {
    SlidingModal,
    TextareaInput,
    MessageBubble,
    ErrorMessages,
    HistoryJobModal,
  },
  mixins: [
    SimpleVueValidator.mixin,
    passEducation,
    jobParams,
    job,
    messages,
    files,
  ],
  data () {
    return {
      newFiles: [],
      newMessage: ' ',
      isCreating: false,
      isUploading: false,
      isHistoryJobModalOpen: false,
      selectedJob: null,
      showGalleryPopup: false,
    };
  },
  computed: {
    ...mapGetters('account/pro/info', [
      'serviceProviderId',
    ]),

    isAndroid () {
      return /Android/i.test(navigator.userAgent);
    },
    isFetching () {
      return (
        this.currentJobMessagesMeta.status
        === this.$options.REQUEST_LIFECYCLE.FETCHING
      );
    },
    isMessagingDisabled () {
      return (
        this.isFetching
        || this.isCreating
        || shouldBeDisabled(this.match.status)
      );
    },
    isSendingDisabled () {
      return (
        (!this.newMessage && !this.hasFiles)
        || this.hasNewMessageError
        || this.isUploading
        || this.isMessagingDisabled
      );
    },
    hasFiles () {
      return this.newFiles.length;
    },
    hasCurrentJobMessagesError () {
      return this.currentJobMessagesMeta.error;
    },
    hasCurrentJobFilesError () {
      return this.currentJobFilesMeta.error;
    },
    hasNewMessageError () {
      return this.validation.hasError('newMessage');
    },
    fullName () {
      return `${this.job.location.first_name} ${this.job.location.last_name}`;
    },
  },
  validators: {
    newMessage (value) {
      return Validator.value(value).maxLength(1024, `Message text is too long (${value.length}), maximum is 1024 characters`);
    },
  },
  watch: {
    jobId (prev, cur) {
      if (prev !== cur) {
        this.clearMessages();
        this.loadMessages();
        this.reconcile();
      }
    },

  },
  async mounted () {
    if (!this.job) {
      await this.fetchJob();
    }
    this.clearMessages();
    await this.loadMessages();
    this.$validate();
  },
  methods: {
    openCamera () {
      if (!this.isMessagingDisabled) {
        this.$refs.cameraInput.click();
      }
    },
    openGallery () {
      if (this.isMessagingDisabled) return;
      if (this.isAndroid) {
        this.showGalleryPopup = true;
      } else {
        this.$refs.galleryInput.click();
      }
    },
    closeGalleryPopup () {
      this.showGalleryPopup = false;
    },

    ...mapActions('dashboard/workOrderMatches', [
      'fetchWorkOrderMatches',
    ]),
    ...mapActions('dashboard/workOrder', [
      'fetchWorkOrder',
    ]),
    ...mapActions('dashboard/workOrders', [
      'fetchWorkOrders',
      'resetWorkOrders',
    ]),
    async fetchJob () {
      await this.fetchWorkOrderMatches({
        params: {
          order_hash: this.jobId,
          service_provider_id: this.serviceProviderId,
        },
      });
    },
    getMessagesLink (feature) {
      return {
        name: 'dashboard::pro::jobs',
        params: this.$route.params,
        query: {
          ...this.$route.query,
          feature,
        },
      };
    },
    reconcile () {
      this.newMessage = '';
      this.newFiles = [];
    },
    async loadMessages (params) {
      await this.fetchMessages({
        jobId: this.jobId,
        params: {
          ...params,
        },
      });
    },
    async loadMoreMessages () { // THIS APPEARS TO BE AN EXISTING ISSUE (DOES NOT WORK WITH OLD API)
      await this.loadMessages({ from: this.currentJobMessagesMeta.count });
    },
    clearMessages () {
      this.resetCurrentMessages();
    },
    onNewMessageCreateWithShiftPlusEnter (event) {
      if (event.shiftKey) {
        event.preventDefault();

        this.onNewMessageCreate();
      }
    },
    async uploadFile (file) {
      const body = new FormData();

      body.append('file', file);

      const data = await this.createFiles({
        jobId: this.job.order_hash,
        skillsProfile: this.serviceProviderId,
        body,
      });

      this.newFiles = [...this.newFiles, data];
    },
    async onNewFilesUpload ({ target }) {
      this.isUploading = true;
      this.showGalleryPopup = false;

      try {
        await Promise.all(Array.from(target.files).map(this.uploadFile));
      // eslint-disable-next-line no-empty
      } catch (error) {} finally {
        this.isUploading = false;
      }
    },
    async onFileDelete (fileId) {
      await this.deleteFiles({
        jobId: this.job.order_hash,
        skillsProfile: this.serviceProviderId,
        fileId,
      });

      this.newFiles = this.newFiles.filter(({ id }) => id !== fileId);
    },
    async onNewMessageCreate () {
      if (this.isSendingDisabled) {
        return;
      }

      this.resetCurrentFilesError();

      this.isCreating = true;

      try {
        await this.createMessages({
          jobId: this.job.order_hash,
          params: {
            message: this.newMessage,
            asset_urls: this.newFiles.map(({ url }) => url),
          },
        });

        this.reconcile();
        this.$emit('message-sent');
        this.$events.$emit(this.$events.PRO_SEND_MESSAGE, {
          jobID: this.job.order_hash,
        });
      } catch (error) {
        this.$events.$emit(this.$events.PRO_SEND_MESSAGE_ERROR, {
          jobID: this.job.order_hash,
        });
      } finally {
        this.isCreating = false;

        if (!this.$device.isMobile) {
          global.setTimeout(() => this.$refs.textarea.$el.focus(), 150);
        }
      }
    },
    openHistoryJobModal () {
      this.$events.$emit(this.$events.PERFORMANCE_HISTORY_MODAL_CLICK, {
        jobId: this.jobId,
      });
      this.selectedJob = this.job;
      this.isHistoryJobModalOpen = true;
    },
    close () {
      this.isHistoryJobModalOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";
  @import "~@/views/Dashboard/tools";

  .MESSAGES {
    height: 75vh;
    @include desktop {
      width: 100%;
    }
  }
  .ICON-BAR {
  display: flex;
  align-items: center;
  gap: 12px; /* space between icons */
}

  .MESSAGES-CONTAINER {
    display: flex;
    flex-direction: column;
    background-color: white;
    overflow-y: hidden;
    transform: none;
    will-change: transform;
    transition: transform $transition-duration;
    position: sticky;
    bottom: 0;
    height: 80vh;
    border: 1px solid $color-gray30;
    margin-bottom: 16px;
    width: 100%;

    @include mobile-only {
      height: 75vh;
    }
}

  .SHADOW {
    @include responsive(box-shadow, 0 0 10px rgba(black, 0.2), $md: none);
    backface-visibility: hidden;
  }

  .HEADER {
    @include padding(0 2, 2 2);
    position: relative;
    display: flex;
    justify-content: space-between;
    width:100%;
    align-items: center;
    border-bottom: 1px solid $color-gray30;
  }

  .SUB-HEADER {
    @include text-medium;
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    padding: 0.75*$unit 2*$unit;
    background-color: $color-gray10;
    border-bottom: 1px solid $color-gray30;
    color: $color-gray70;
  }

  .ICON {
    @include absolute(50%, auto, auto, 2*$unit);
    @include square(3*$unit);
    @include desktop-hover(opacity, 0.7, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    transform: translateY(-50%);
    will-change: opacity;
    transition: opacity $transition-half-duration;

    @include tablet {
      @include absolute(50%, 2*$unit, auto, auto);
    }
  }
  .USER-ICON {
    margin: $unit;
    @include square(4*$unit);
  }

  .MESSAGES-LIST-CONTAINER {
    height: 100%;
    display: flex;
    flex: 1 1 auto;
    flex-direction: column-reverse;
    padding: $unit 2*$unit;
    overflow-y: scroll;
  }

  .GROUP {
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;
  }

  .FILES-CONTAINER {
    display: flex;
    flex: 0 0 auto;
    flex-direction: row-reverse;
    height: 103px;
    padding: 2*$unit;
    border-top: 1px solid $color-gray30;
    overflow-x: scroll;

    // https://www.geeksforgeeks.org/hide-scroll-bar-but-while-still-being-able-to-scroll-using-css/
    // https://developer.mozilla.org/en-US/docs/Web/CSS/scrollbar-width
    scrollbar-width: none;
    overflow: -moz-scrollbars-none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      width: 0 !important;
      height: 0 !important;
    }

    &.DISABLED {
      pointer-events: none;
      opacity: 0.3;
    }
  }

  .FILES {
    flex-wrap: nowrap;
    overflow: visible !important;
  }

  .ERROR {
    @include text-medium;
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    padding: $unit 2*$unit;
    background-color: $color-red;
    color: white;
  }

  .TEXTAREA-CONTAINER {
    position: relative;
    display: flex;
    flex: 0 0 auto;
  }

  .HIDDEN {
    display: none;
  }

  .TEXTAREA {
    display: flex;
    min-height: 57px;
    max-height: 153px;
    padding: 2*$unit 8*$unit;
    border: none;
    border-top: 1px solid $color-gray30;
    will-change: height, opacity;
    transition: height $transition-half-duration,
      opacity $transition-half-duration;
    backface-visibility: hidden;
    overflow-y: scroll;
  }

  .SEND,
  .ATTACH {
    @include square(25px);
    @include h4;
    @include absolute(50%, 2*$unit, auto, auto);
    display: flex;
    transform: translateY(-50%);
    align-items: center;
    justify-content: center;
    z-index: 2;
    will-change: color, opacity;
    transition: color $transition-half-duration, opacity $transition-half-duration;
  }

  .ATTACHGALLERY {
    @include square(25px);
    @include h4;
    position: absolute;
    left: 40px;
    top: 50%;    //@include absolute(50%, 2*$unit, auto, auto);

    //@include absolute(50%, 2*$unit, auto, auto);
    display: flex;
    transform: translateY(-50%);
    align-items: center;
    justify-content: center;
    z-index: 2;
    will-change: color, opacity;
    transition: color $transition-half-duration, opacity $transition-half-duration;

  }

  .SEND {
    @include link-primary;
  }

  .ATTACH {
    @include link-black;
    left: 2*$unit;
    right: auto;
    z-index: 2;
  }

  .DISABLED {
    @include hover(color, $color-gray40, $color-gray40);
    color: $color-gray40;
    cursor: not-allowed;
  }

  .LIST-ITEM {
    transition: all $transition-half-duration;
  }

  .FADE-AND-MOVE-enter-active,
  .FADE-AND-MOVE-leave-active {
    opacity: 1;
    will-change: opacity;
    transition: opacity $transition-half-duration;

    &.FADE-AND-MOVE-enter,
    &.FADE-AND-MOVE-leave-to {
      opacity: 0;
    }
  }
  .LARGE-ICON {
  font-size: 48px !important;
  width: 48px !important;
  height: 48px !important;
  margin-right: 5px;
  /* Optional: adjust line-height for vertical alignment */
  line-height: 48px !important;
}
.gallery-popup-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.gallery-popup {
  background: #fff;
  padding: 24px;
  border-radius: 8px;
  min-width: 240px;
  text-align: center;
}
  .popup-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }
  .BUTTON {
    border: 1px solid $color-depot;
    line-height: 22px;
    color: #fff;
    background-color: $color-depot;
    border-radius: 3px;
    height: 28px;
    .TEXT {
      font-size: 14px;
    }
  }
    .BUTTONCLOSE {
    border: 1px solid $color-depot;
    line-height: 22px;
    color: $color-depot;
    background-color: white;
    border-radius: 3px;
    height: 28px;
    .TEXT {
      font-size: 14px;
    }
  }

  .UPLOAD-LOADER-OVERLAY {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.7);
    z-index: 10000;
  }

  .FADE-AND-MOVE-leave-active {
    @include absolute;
  }
</style>
